// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/mirror.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const mirror: Score = {
  slug: "mirror",
  n: 28,
  title: "Mirror",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 84,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 41,
  highest: 71,
  hasLyrics: false,
  jasonNote: "Both hands start on a C and then walk away from each other, one going up while the other goes down. If it feels strange, that is the point \u2014 your hands are used to agreeing. Read one hand at a time first.",
  teaches: ["contrary motion", "reading two staves at once", "hands doing opposite things"],
  art: "/sight-reading/art/mirror.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/mirror.jpg",
  newForThisEdition: true,
  fillsGap: "The printed book never moves the hands in opposite directions.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 1, hand: "lh", start: 0.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 1, hand: "lh", start: 1.0, dur: 1.0, midi: 47, pitch: "B2", d: "quarter" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 1, hand: "lh", start: 2.0, dur: 1.0, midi: 45, pitch: "A2", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 1, hand: "lh", start: 3.0, dur: 1.0, midi: 43, pitch: "G2", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 2, hand: "lh", start: 4.0, dur: 2.0, midi: 41, pitch: "F2", d: "half" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 65, pitch: "F4", d: "half" },
    { bar: 2, hand: "lh", start: 6.0, dur: 2.0, midi: 43, pitch: "G2", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 3, hand: "lh", start: 8.0, dur: 1.0, midi: 45, pitch: "A2", d: "quarter" },
    { bar: 3, hand: "rh", start: 9.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 3, hand: "lh", start: 9.0, dur: 1.0, midi: 47, pitch: "B2", d: "quarter" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 3, hand: "lh", start: 10.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 3, hand: "lh", start: 11.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole" },
    { bar: 4, hand: "lh", start: 12.0, dur: 4.0, midi: 48, pitch: "C3", d: "whole" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 5, hand: "lh", start: 16.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 5, hand: "lh", start: 17.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 5, hand: "lh", start: 18.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 5, hand: "lh", start: 19.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 6, hand: "rh", start: 20.0, dur: 2.0, midi: 71, pitch: "B4", d: "half" },
    { bar: 6, hand: "lh", start: 20.0, dur: 2.0, midi: 48, pitch: "C3", d: "half" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 6, hand: "lh", start: 22.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 7, hand: "lh", start: 24.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 7, hand: "rh", start: 25.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter" },
    { bar: 7, hand: "lh", start: 25.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 7, hand: "lh", start: 26.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 7, hand: "lh", start: 27.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole" },
    { bar: 8, hand: "lh", start: 28.0, dur: 4.0, midi: 48, pitch: "C3", d: "whole" },
  ],
};
